import dayjs from "dayjs"
import Loading from "../../components/Common/Loading";
import {DataGridPro} from "@mui/x-data-grid-pro";
import {useGetPaymentsV1DSQuery} from "../../core/api/ds-analytical-data-api";
import {Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {useState} from "react";
import DSPurchaseItem from "../Analytics/ds/DSPurchaseItem";
import {paymentUserStatus} from "../../core/utils/constants";

const PaymentsDS = (props) => {

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        isFetching,
        error
    } = useGetPaymentsV1DSQuery(props.deviceId)

    let payments = ""
    let total = 0

    const [state, setState] = useState({
        showDetails: false,
        selectedPayload: '',
        selectedDate: ''
    })

    const handleViewDetails = (item) => {
        setState({
            ...state,
            showDetails: true,
            selectedPayload: item.payload,
            selectedDate: item.timestamp
        })
    }

    const columns = [
        {
            field: 'action',
            headerName: 'Purchases',
            renderCell: (params) => {
                // Assuming isAdmin is available in the component's scope
                return <IconButton
                    aria-label="edit"
                    onClick={() => handleViewDetails(params.row)}
                >
                    <SearchIcon />
                </IconButton>
            },
            sortable: false,
            filterable: false,
        },
        {
            headerName: 'Currency',
            field: 'currency',
            width: 70
        },
        {
            headerName: 'Price',
            field: 'price',
            width: 120,
            renderCell: (params) => {
                return params.value/100
            }
        },
        {
            headerName: 'USD Price',
            field: 'usdPrice',
            width: 120,
            renderCell: (params) => {
                return params.value/100
            }
        },
        {
            headerName: 'Purchase Network',
            field: 'purchaseNetwork',
            width: 120
        },
        {
            headerName: 'Transaction ID',
            field: 'transactionId',
            width: 120
        },
        {
            headerName: 'S Transaction ID',
            field: 'sTransactionId',
            width: 120,
            valueGetter: (value) => value ? value : "-"
        },
        {
            headerName: 'Transaction Time',
            field: 'transactionTime',
            width: 120,
                valueGetter: (value) => value ? dayjs(value).format("DD.MM.YYYY HH:mm:ss.SSS") : "-"
        },
        {
            headerName: 'Timestamp',
            field: 'timestamp',
            width: 120,
            valueGetter: (value) => value ? dayjs(value).format("DD.MM.YYYY HH:mm:ss.SSS") : "-"
        },
        {
            headerName: 'Store ID',
            field: 'storeId',
            width: 120,
        },
        {
            headerName: 'Category',
            field: 'category',
            width: 120,

        },
        {
            headerName: 'Item',
            field: 'item',
            width: 200,

        },
        {
            headerName: 'Is test payment',
            field: 'sourceTable',
            width: 150,
            renderCell: (params) => {
                return params.value==='payments_test'?'TEST':''
            }
        },
    ]


    if (typeof data === "object") {
        payments = <DataGridPro
            getRowId={(row) => row.transactionId+row.transactionTime}
            getRowHeight={() => "auto"}
            rows={data}
            columns={columns}

            getRowClassName={(params) =>
                params.row.sourceTable === 'payments_test' ? 'payments-test-row' : ''
            }

        />
        total = data.reduce((sum, item) => sum + (item.usdPrice || 0), 0 )
        total = total/100
    } else {
        payments = "no data"
    }

    return (
        <>
            <Loading
                isLoading={isLoading||isFetching}
                isError={isError}
                error={error}
                isSuccess={isSuccess}
            >

                <Card>Total: {total} Segment: {paymentUserStatus(total)}</Card>
                {payments}

            </Loading>
            {state.showDetails &&
                <Dialog
                    maxWidth={"xl"}
                    fullWidth={true}
                    scroll={"paper"}
                    open={state.showDetails}
                    onClose={() => setState({
                        ...state,
                        showDetails: false
                    })}>
                    <DialogContent>
                        <DSPurchaseItem deviceId={props.deviceId}
                                         payload={state.selectedPayload}
                                         date={state.selectedDate}/>
                    </DialogContent>
                    <DialogActions>

                        <Button variant="outlined"
                                onClick={() => setState({
                                    ...state,
                                    showDetails: false
                                })}>
                            Close
                        </Button>

                    </DialogActions>


                </Dialog>}
        </>
    )
}

export default PaymentsDS
